import React from 'react';

const ArticleContent = ({ coverImage, title, description }) => {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        {/* Cover Image */}
        {coverImage && (
          <div className="mb-8">
            <img
              src={coverImage}
              alt={title}
              className="w-full h-96 object-cover rounded-xl shadow-lg"
            />
          </div>
        )}
        
        {/* Article Content */}
        <div className="prose prose-lg max-w-none">
          <div 
            dangerouslySetInnerHTML={{ 
              __html: description 
            }}
            className="text-gray-700 leading-relaxed text-justify"
          />
        </div>
      </div>
    </section>
  );
};

export default ArticleContent;